import React from "react";

export const LaurelLeft = () => {
  return (
    <svg
      width="81px"
      height="165px"
      viewBox="0 0 81 165"
      preserveAspectRatio="xMinYMid meet"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="worldOrg_dots"
          transform="translate(-252.000000, -170.000000)"
          fill="#5C6BBF"
        >
          <g id="Group-10" transform="translate(247.000000, 164.000000)">
            <g id="Group-6" transform="translate(0.000000, 4.192679)">
              <path
                d="M73.3916267,157.215535 C62.1212694,149.445579 52.7893963,156.231611 44.246343,163.909426 C55.2991037,166.930702 67.0005764,168.313901 73.3916267,157.215535 Z"
                id="path1872"
                transform="translate(58.818985, 159.916710) rotate(22.000000) translate(-58.818985, -159.916710) "
              />
              <path
                d="M77.7625836,152.084981 C77.2373477,138.430792 66.1927716,134.975402 54.9056972,132.682307 C59.1115621,143.342009 65.0212738,153.549291 77.7625836,152.084981 Z"
                id="path2784"
                transform="translate(66.334140, 142.453987) rotate(22.000000) translate(-66.334140, -142.453987) "
              />
              <path
                d="M57.5163455,143.943622 C46.9394906,135.251765 37.0643447,141.222958 27.9000637,148.149101 C38.6614543,152.092397 50.2079171,154.458799 57.5163455,143.943622 Z"
                id="path2790"
                transform="translate(42.708205, 145.553917) rotate(22.000000) translate(-42.708205, -145.553917) "
              />
              <path
                d="M55.9874256,139.4141 C62.545606,127.452568 54.8191428,118.826795 46.287371,111.071866 C44.4325859,122.357745 44.2757027,134.130462 55.9874256,139.4141 Z"
                id="path2796"
                transform="translate(51.896510, 125.242983) rotate(22.000000) translate(-51.896510, -125.242983) "
              />
              <path
                d="M44.3502389,131.033895 C36.559397,119.779617 25.4126185,122.801219 14.6875231,126.935325 C23.9615212,133.67957 34.4247117,139.125012 44.3502389,131.033895 Z"
                id="path2802"
                transform="translate(29.518881, 129.143736) rotate(22.000000) translate(-29.518881, -129.143736) "
              />
              <path
                d="M41.7295781,124.146524 C51.765704,114.911231 47.181209,104.284554 41.5548819,94.225828 C36.19808,104.319409 32.2976292,115.414618 41.7295781,124.146524 Z"
                id="path2808"
                transform="translate(41.828503, 109.186176) rotate(22.000000) translate(-41.828503, -109.186176) "
              />
              <path
                d="M34.2520995,114.959851 C28.7390469,102.437742 17.2128494,103.282531 5.88928108,105.298893 C13.7175367,113.678554 22.9612355,121.010174 34.2520995,114.959851 Z"
                id="path2814"
                transform="translate(20.070690, 110.652548) rotate(22.000000) translate(-20.070690, -110.652548) "
              />
              <path
                d="M32.9627276,107.27045 C44.5452016,100.062776 42.0085944,88.7778865 38.3421291,77.8575167 C31.2018412,86.7756221 25.3078275,96.9473082 32.9627276,107.27045 Z"
                id="path2820"
                transform="translate(35.395167, 92.563983) rotate(22.000000) translate(-35.395167, -92.563983) "
              />
              <path
                d="M28.0713591,97.8252666 C25.02259,84.4957711 13.5362976,83.1456193 2.02750155,82.9833711 C8.13497075,92.6858266 15.8316126,101.627496 28.0713591,97.8252666 Z"
                id="path2826"
                transform="translate(15.049430, 90.852063) rotate(22.000000) translate(-15.049430, -90.852063) "
              />
              <path
                d="M33.6934769,85.2260207 C46.0303461,79.3946552 44.8018302,67.8984991 42.4086443,56.6349775 C34.2907757,64.6732669 27.2679491,74.0990063 33.6934769,85.2260207 Z"
                id="path2832"
                transform="translate(37.574381, 70.930499) rotate(22.000000) translate(-37.574381, -70.930499) "
              />
              <path
                d="M29.445369,81.6122225 C28.0000969,68.0211473 16.7502584,65.3176121 5.3369636,63.7903649 C10.251503,74.1448057 16.8350571,83.9328375 29.445369,81.6122225 Z"
                id="path2838"
                transform="translate(17.391166, 72.873534) rotate(22.000000) translate(-17.391166, -72.873534) "
              />
              <path
                d="M36.4578133,63.6756967 C49.796507,60.7525555 51.1675182,49.2823242 51.3503299,37.7784793 C41.6342475,43.793343 32.6763328,51.404026 36.4578133,63.6756967 Z"
                id="path2844"
                transform="translate(43.461167, 50.727088) rotate(22.000000) translate(-43.461167, -50.727088) "
              />
              <path
                d="M31.2952974,66.6126161 C35.1323137,53.5144311 25.7429041,46.7368902 15.7541748,40.9831656 C16.3627114,52.4134174 18.7326801,63.9559196 31.2952974,66.6126161 Z"
                id="path2850"
                transform="translate(23.963760, 53.797891) rotate(22.000000) translate(-23.963760, -53.797891) "
              />
              <path
                d="M49.7358259,42.9367302 C63.386387,43.6459131 67.7433489,32.9576972 70.9620826,21.9230635 C59.9912656,25.1499311 49.3303825,30.1146128 49.7358259,42.9367302 Z"
                id="path2856"
                transform="translate(60.343350, 32.446615) rotate(22.000000) translate(-60.343350, -32.446615) "
              />
              <path
                d="M38.6239627,48.7757695 C46.806029,37.8636674 40.3681943,28.2402395 33.0099206,19.3650733 C29.5820651,30.2711115 27.7674686,41.8980211 38.6239627,48.7757695 Z"
                id="path2862"
                transform="translate(36.401142, 34.070421) rotate(22.000000) translate(-36.401142, -34.070421) "
              />
              <path
                d="M63.022184,26.7414442 C76.6643296,25.980374 79.8453921,14.8816076 81.858046,3.56056446 C71.3021154,7.94863309 61.2409968,14.031867 63.022184,26.7414442 Z"
                id="path2868"
                transform="translate(72.337096, 15.151004) rotate(22.000000) translate(-72.337096, -15.151004) "
              />
              <path
                d="M52.4702824,31.2985587 C62.7045716,22.2830683 58.3505371,11.560671 52.9425496,1.38352897 C47.3683181,11.3581615 43.2285599,22.3655761 52.4702824,31.2985587 Z"
                id="path2874"
                transform="translate(52.840290, 16.341044) rotate(22.000000) translate(-52.840290, -16.341044) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const LaurelRight = () => {
  return (
    <svg
      width="80px"
      height="165px"
      viewBox="0 0 80 165"
      preserveAspectRatio="xMaxYMid meet"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="worldOrg_dots"
          transform="translate(-689.000000, -170.000000)"
          fill="#5C6BBF"
        >
          <g id="Group-10" transform="translate(247.000000, 164.000000)">
            <g id="Group-8" transform="translate(442.000000, 4.192679)">
              <path
                d="M41.7197623,157.215535 C30.4494049,149.445579 21.1175319,156.231611 12.5744785,163.909426 C23.6272392,166.930702 35.3287119,168.313901 41.7197623,157.215535 Z"
                id="path1872"
                transform="translate(27.147120, 159.916710) scale(-1, 1) rotate(22.000000) translate(-27.147120, -159.916710) "
              />
              <path
                d="M31.0604081,152.084981 C30.5351722,138.430792 19.4905961,134.975402 8.20352169,132.682307 C12.4093866,143.342009 18.3190984,153.549291 31.0604081,152.084981 Z"
                id="path2784"
                transform="translate(19.631965, 142.453987) scale(-1, 1) rotate(22.000000) translate(-19.631965, -142.453987) "
              />
              <path
                d="M58.0660416,143.943622 C47.4891867,135.251765 37.6140408,141.222958 28.4497598,148.149101 C39.2111504,152.092397 50.7576132,154.458799 58.0660416,143.943622 Z"
                id="path2790"
                transform="translate(43.257901, 145.553917) scale(-1, 1) rotate(22.000000) translate(-43.257901, -145.553917) "
              />
              <path
                d="M38.160511,139.4141 C44.7186914,127.452568 36.9922282,118.826795 28.4604563,111.071866 C26.6056713,122.357745 26.4487881,134.130462 38.160511,139.4141 Z"
                id="path2796"
                transform="translate(34.069595, 125.242983) scale(-1, 1) rotate(22.000000) translate(-34.069595, -125.242983) "
              />
              <path
                d="M71.2785822,131.033895 C63.4877404,119.779617 52.3409619,122.801219 41.6158664,126.935325 C50.8898645,133.67957 61.353055,139.125012 71.2785822,131.033895 Z"
                id="path2802"
                transform="translate(56.447224, 129.143736) scale(-1, 1) rotate(22.000000) translate(-56.447224, -129.143736) "
              />
              <path
                d="M44.038677,124.146524 C54.0748029,114.911231 49.4903079,104.284554 43.8639808,94.225828 C38.5071789,104.319409 34.6067281,115.414618 44.038677,124.146524 Z"
                id="path2808"
                transform="translate(44.137602, 109.186176) scale(-1, 1) rotate(22.000000) translate(-44.137602, -109.186176) "
              />
              <path
                d="M80.0768242,114.959851 C74.5637716,102.437742 63.0375741,103.282531 51.7140058,105.298893 C59.5422614,113.678554 68.7859602,121.010174 80.0768242,114.959851 Z"
                id="path2814"
                transform="translate(65.895415, 110.652548) scale(-1, 1) rotate(22.000000) translate(-65.895415, -110.652548) "
              />
              <path
                d="M48.1384978,107.27045 C59.7209719,100.062776 57.1843646,88.7778865 53.5178994,77.8575167 C46.3776115,86.7756221 40.4835978,96.9473082 48.1384978,107.27045 Z"
                id="path2820"
                transform="translate(50.570938, 92.563983) scale(-1, 1) rotate(22.000000) translate(-50.570938, -92.563983) "
              />
              <path
                d="M83.9386037,97.8252666 C80.8898347,84.4957711 69.4035422,83.1456193 57.8947462,82.9833711 C64.0022154,92.6858266 71.6988572,101.627496 83.9386037,97.8252666 Z"
                id="path2826"
                transform="translate(70.916675, 90.852063) scale(-1, 1) rotate(22.000000) translate(-70.916675, -90.852063) "
              />
              <path
                d="M44.5108196,85.2260207 C56.8476888,79.3946552 55.6191729,67.8984991 53.2259869,56.6349775 C45.1081184,64.6732669 38.0852918,74.0990063 44.5108196,85.2260207 Z"
                id="path2832"
                transform="translate(48.391724, 70.930499) scale(-1, 1) rotate(22.000000) translate(-48.391724, -70.930499) "
              />
              <path
                d="M80.6291417,81.6122225 C79.1838695,68.0211473 67.934031,65.3176121 56.5207362,63.7903649 C61.4352756,74.1448057 68.0188297,83.9328375 80.6291417,81.6122225 Z"
                id="path2838"
                transform="translate(68.574939, 72.873534) scale(-1, 1) rotate(22.000000) translate(-68.574939, -72.873534) "
              />
              <path
                d="M35.5015848,63.6756967 C48.8402785,60.7525555 50.2112897,49.2823242 50.3941015,37.7784793 C40.678019,43.793343 31.7201043,51.404026 35.5015848,63.6756967 Z"
                id="path2844"
                transform="translate(42.504938, 50.727088) scale(-1, 1) rotate(22.000000) translate(-42.504938, -50.727088) "
              />
              <path
                d="M69.3338833,66.6126161 C73.1708995,53.5144311 63.7814899,46.7368902 53.7927606,40.9831656 C54.4012972,52.4134174 56.7712659,63.9559196 69.3338833,66.6126161 Z"
                id="path2850"
                transform="translate(62.002346, 53.797891) scale(-1, 1) rotate(22.000000) translate(-62.002346, -53.797891) "
              />
              <path
                d="M15.0152306,42.9367302 C28.6657916,43.6459131 33.0227535,32.9576972 36.2414872,21.9230635 C25.2706702,25.1499311 14.6097871,30.1146128 15.0152306,42.9367302 Z"
                id="path2856"
                transform="translate(25.622755, 32.446615) scale(-1, 1) rotate(22.000000) translate(-25.622755, -32.446615) "
              />
              <path
                d="M51.7877833,48.7757695 C59.9698496,37.8636674 53.5320149,28.2402395 46.1737412,19.3650733 C42.7458857,30.2711115 40.9312892,41.8980211 51.7877833,48.7757695 Z"
                id="path2862"
                transform="translate(49.564963, 34.070421) scale(-1, 1) rotate(22.000000) translate(-49.564963, -34.070421) "
              />
              <path
                d="M4.3140968,26.7414442 C17.9562424,25.980374 21.1373048,14.8816076 23.1499588,3.56056446 C12.5940282,7.94863309 2.53290953,14.031867 4.3140968,26.7414442 Z"
                id="path2868"
                transform="translate(13.629009, 15.151004) scale(-1, 1) rotate(22.000000) translate(-13.629009, -15.151004) "
              />
              <path
                d="M32.7558071,31.2985587 C42.9900964,22.2830683 38.6360619,11.560671 33.2280744,1.38352897 C27.6538429,11.3581615 23.5140847,22.3655761 32.7558071,31.2985587 Z"
                id="path2874"
                transform="translate(33.125815, 16.341044) scale(-1, 1) rotate(22.000000) translate(-33.125815, -16.341044) "
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
